import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import Button from "../sharedUI/Button";
import Card from "../sharedUI/Card";
import { Loader } from "../sharedUI/FullScreenLoader";
import Input from "../sharedUI/Input";
import { breakPoints, measurments } from "../utils/config";
import { fetcher } from "../utils/fetcher";
import { useQuery } from "../utils/useQuery";

const StyledRegister = styled.div`
  .center-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100vw;
    height: 100vh;
    text-align: center;
  }
  height: 100vh;
  display: flex;
  flex-direction: column;
  .logo {
    width: 200px;
  }
  .form-container {
    display: flex;
    align-items: center;
    justify-content: center;
    form {
      width: 400px;
      max-width: 100%;
    }
  }
  .two-col {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
    flex-grow: 1;
  }
  .image-container {
    border-radius: ${measurments.borderRadius}px 0 0
      ${measurments.borderRadius}px;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 50vw;
    height: 100vh;
    background: url(/images/placeholder-1.jpg);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }
  .logo-mobile {
    display: none;
  }
  .nav-minimal {
    padding-top: 1rem;
    padding-left: 1rem;
  }
  ${breakPoints.tablet} {
    padding: 1rem;
    .image-container {
      display: none;
    }
    .two-col {
      grid-template-columns: 1fr;
    }
    .container-fw {
      padding: 0;
    }
    .form-container {
      width: 100%;
      .form-wrap {
        width: 100%;
      }
      form {
        width: 100%;
      }
    }
    .logo {
      display: none;
    }
    .logo-mobile {
      display: block;
      width: 24px;
    }
  }
`;

const Register = ({ login, globalState, setGlobalState, notify }) => {
  const navigate = useNavigate();
  const urlToken = useQuery().get("t");

  //States
  const [formData, setFormData] = useState({
    repeatPassword: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);
  const [verified, setVerified] = useState(false);
  const [userFromToken, setUserFromToken] = useState();

  //Functions
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.password !== formData.repeatPassword) {
      notify.error("Lösenorden stämmer inte överens");
      return;
    }
    setLoading(true);
    const { err } = await fetcher({
      path: "users-no-auth/create-password",
      method: "POST",
      body: { password: formData.password },
      auth: urlToken,
    });
    if (err) {
      notify.error("Lösenordet uppfyller inte kraven");
      setLoading(false);
      return;
    }
    login(
      { email: userFromToken.email, password: formData.password },
      (data) => {
        notify.success(`Välkommen ${data.user.firstName}!`);
      },
      (error) => {
        setLoading(false);
        notify.success(error);
      }
    );
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const verifyToken = async (token) => {
    const { err, data } = await fetcher({
      path: "users-no-auth/verify-register-token",
      auth: token,
    });
    if (err) return false;
    else return data;
  };

  const checkUser = async () => {
    console.log("checking user");
    const storedToken = localStorage.getItem("bg-kurswebb-user-token");
    if (globalState.user) navigate("/", { replace: true });
    else if (storedToken) {
      setGlobalState({
        ...globalState,
        appLoading: true,
      });

      const user = await verifyToken(storedToken);
      if (!user) {
        localStorage.removeItem("bg-kurswebb-user-token");
        setGlobalState({
          ...globalState,
          appLoading: false,
        });
        return;
      }
      setGlobalState({
        ...globalState,
        user,
        token: storedToken,
      });
    } else {
      setGlobalState({
        ...globalState,
        appLoading: false,
      });
      localStorage.removeItem("bg-kurswebb-user-token");
    }
  };

  const confirmUrlToken = async () => {
    const { err, data } = await fetcher({
      path: "users-no-auth/verify-register-token",
      auth: urlToken,
    });
    console.log("token-err_ ", err);
    if (err) {
      setVerified(false);
      setLoading(false);
    } else {
      setUserFromToken(data);
      setVerified(true);
      setLoading(false);
    }
  };

  //Effects
  useEffect(() => {
    checkUser();
    //eslint-disable-next-line
  }, [globalState.user]);

  useEffect(() => {
    confirmUrlToken();
    //eslint-disable-next-line
  }, [urlToken]);

  if (loading)
    return (
      <StyledRegister>
        <div className="center-wrapper">
          <Loader />
        </div>
      </StyledRegister>
    );
  else if (!loading && !verified)
    return (
      <StyledRegister>
        <div className="center-wrapper">
          <h1 className="m0">Felaktig länk</h1>
        </div>
      </StyledRegister>
    );
  else if (!loading && verified)
    return (
      <StyledRegister>
        <div className="nav-minimal">
          <img
            src="/images/logo-horizontal.png"
            alt="Brommagymnasterna"
            className="logo"
          />
          <img
            src="/images/logo-symbol.png"
            alt="Brommagymnasterna"
            className="logo-mobile"
          />
        </div>
        {/* </a> */}
        <div className="two-col">
          <div className="image-container" />
          <div className="form-container">
            <div className="form-wrap">
              <h1 className="h1 m0 mbottom1">Tränarportalen</h1>
              <Card>
                <p className="h3 m0 mbottom1">Skapa ditt konto</p>
                <form onSubmit={handleSubmit}>
                  <Input
                    label="Välj lösenord"
                    type="password"
                    value={formData.password}
                    name="password"
                    disabled={loading}
                    onChange={handleChange}
                    placeholder="Lösenord"
                  />
                  <Input
                    label="Upprepa lösenord"
                    type="password"
                    value={formData.repeatPassword}
                    name="repeatPassword"
                    disabled={loading}
                    onChange={handleChange}
                    placeholder="Upprepa lösenord"
                  />
                  <div className="flex mtop2">
                    <Button
                      className="b2"
                      type="submit"
                      disabled={loading}
                      btnType="primary"
                    >
                      {loading ? "Skapar konto..." : "Skapa konto"}
                    </Button>
                  </div>
                </form>
              </Card>
              <Card className="card mtop1">
                <p className="m0 mbottom1 h3">Lösenordskrav</p>
                <ul>
                  <li>Mins 8 tecken</li>
                  <li>Minst en liten bokstav</li>
                  <li>Minst en stor bokstav</li>
                  <li>Minst en siffra</li>
                </ul>
              </Card>
            </div>
          </div>
        </div>
      </StyledRegister>
    );
  else return null;
};

export default Register;
